import { TYPE_A, TYPE_B, TYPE_C, TYPE_K, TYPE_L } from '../../common/constants/img';
import {
  DESIGN_INLINE_VERTICAL,
  DESIGN_STANDARD,
  DESIGN_VERTICAL,
  DESKTOP_TYPE_PADDING_DIVIDER,
  MOBILE_TYPE_PADDING_DIVIDER,
  SIZE_LARGE,
} from '../constants/carousels';
import breakpoints from '@/mui/constants/breakpoints';

export const slideDimensions = (design, format, width) => {
  const isSmallScreen = width <= breakpoints.values.x2l;

  if ([DESIGN_VERTICAL, DESIGN_INLINE_VERTICAL].includes(design)) {
    return isSmallScreen ? TYPE_L : TYPE_K;
  }

  let dimensions = isSmallScreen ? TYPE_C : TYPE_B;

  if (design === DESIGN_STANDARD && format === SIZE_LARGE) {
    const padding = isSmallScreen ? MOBILE_TYPE_PADDING_DIVIDER : DESKTOP_TYPE_PADDING_DIVIDER;

    const slideSize = width - padding;

    if (slideSize < TYPE_B.width) {
      dimensions = TYPE_C;
    } else if (slideSize < TYPE_A.width) {
      dimensions = TYPE_B;
    } else {
      dimensions = TYPE_A;
    }
  }

  return dimensions;
};
